/** SystemAuditRoute — skin-aware switcher for /system-audit. */
import { useUISkin } from "@/data/UISkinContext";
import SystemAudit from "./SystemAudit";
import { CockpitFrame } from "@/components/cockpit/CockpitFrame";

export default function SystemAuditRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") {
    return (
      <CockpitFrame eyebrow="Admin · Governance" title="System Audit">
        <SystemAudit />
      </CockpitFrame>
    );
  }
  return <SystemAudit />;
}
